import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa5c2292"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "update-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-others" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          (_ctx.$props.i18n.locale.value === 'en')
            ? (_openBlock(), _createBlock(_component_SignalText, {
                key: 0,
                signal: "caution"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_3')), 1)
          ]),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_5')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_6')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_7')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_5')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_8')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_6')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_9')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_10')), 1)
          ]),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_4')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_7')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_5')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_8')), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$props.i18n.$text('h2_6')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_9')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_7')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_10')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_11')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_1'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_1')), 9, _hoisted_1)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_12')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_2'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_2')), 9, _hoisted_2),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_en')), 1)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_13')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_3'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_3')), 9, _hoisted_3)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_14')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_4'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_4')), 9, _hoisted_4),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_en')), 1)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_15')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_5'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_5')), 9, _hoisted_5),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_en')), 1)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_16')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_6'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_6')), 9, _hoisted_6)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_17')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_7'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_7')), 9, _hoisted_7),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_en')), 1)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_18')), 1),
              _createElementVNode("a", {
                href: _ctx.$props.i18n.$text('link_18'),
                target: "_blank"
              }, _toDisplayString(_ctx.$props.i18n.$text('link_18')), 9, _hoisted_8)
            ])
          ]),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_8')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('p_11_1')), 1),
            _createVNode(_component_router_link, { to: "/faq_contact" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_8')), 1)
              ]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('p_11_2')), 1)
          ]),
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$props.i18n.$text('update_date')), 1)
        ])
      ]),
      _: 1
    })
  ], 64))
}